import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserloginComponent } from './components/userlogin/userlogin.component';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { UserregisterComponent } from './components/userregister/userregister.component';
import { MyTaskComponent } from './components/my-task/my-task.component';
import { ProfileComponent } from './components/profile/profile.component';
import { OrdersComponent } from './components/orders/orders.component';
// import { FooterComponent } from './components/shared/footer/footer.component';
// import { BgSliderComponent } from './components/shared/bg-slider/bg-slider.component';
import { SharedModule } from './components/shared/shared.module';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { ForgotComponent } from './components/forgot/forgot.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SignupComponent } from './components/signup/signup.component';
import { OtpComponent } from './components/otp/otp.component';
import { NewpassComponent } from './components/newpass/newpass.component';
import { SliderComponent } from './components/slider/slider.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ActionComponent } from './components/action/action.component';
import { TaskcostComponent } from './components/taskcost/taskcost.component';
import { PaymentComponent } from './components/payment/payment.component';
import { CartComponent } from './components/cart/cart.component';
import { NotificationComponent } from './components/notification/notification.component';
import { AddbalanceComponent } from './components/profile/addbalance/addbalance.component';
import { DebitsuccessComponent } from './components/payment/debitsuccess/debitsuccess.component';
import { UploadphotoComponent } from './components/profile/uploadphoto/uploadphoto.component';

import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgImageSliderModule } from 'ng-image-slider';
import { CarouselModule } from 'ng-carousel-cdk';
import { ImageCropperModule } from 'ngx-image-cropper';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CancelsensorComponent } from './components/cancelsensor/cancelsensor.component';
import { AuthService } from './services/auth.service';
import { ObserversModule } from '@angular/cdk/observers';
import { InnerTaskComponent } from './components/my-task/inner-task/inner-task.component';
import { ResetpasswordComponent } from './components/forgot/resetpassword/resetpassword.component';
import { DeleteComponent } from './components/cart/delete/delete.component';
import { GlobeComponent } from './globe/globe.component';
import { ValidationService } from './services/validation.service';
import { SuccessComponent } from './components/forgot/resetpassword/success/success.component';
import { ConfirmDialog } from './components/taskcost/confirmdialog';

import { SafePipe } from 'src/app/services/safe.service';
import { PaypalsuccessComponent } from './components/paypalsuccess/paypalsuccess.component';
import { ErrorComponent } from './components/error/error.component';
import { PaymentsuccessComponent } from './components/paypalsuccess/paymentsuccess/paymentsuccess.component';
import { NoCartComponent } from './components/cart/no-cart/no-cart.component';
import { RequestDemoComponent } from './components/request-demo/request-demo.component';

import { OpenconfirmwarningComponent } from './components/newtask/openconfirmwarning/openconfirmwarning.component';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { RegistersuccessComponent } from './components/userregister/registersuccess/registersuccess.component';
import { DatePipe } from '@angular/common';
import { CountrycheckComponent } from './components/taskcost/countrycheck/countrycheck.component';
import { CancelinvoiceComponent } from './components/orders/cancelinvoice/cancelinvoice.component';
import { CancelpaylaterComponent } from './components/payment/cancelpaylater/cancelpaylater.component';
import { JwtInterceptor } from './services/JwtInterceptor ';
import { AuthInterceptor } from './services/AuthInterceptor';
import { SatellogicWarningComponent } from './components/taskcost/satellogic-warning/satellogic-warning.component';
import { NgxOtpInputModule } from 'ngx-otp-input';
import { SubscriptionComponent } from './components/subscription/subscription.component';
import { DesktopVersionComponent } from './components/my-task/desktop-version/desktop-version.component';
import { DepositsComponent } from './components/deposits/deposits.component';
import { ToiWarningPopupComponent } from './components/my-task/toi-warning-popup/toi-warning-popup.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { FeasibilityComponent } from './components/my-task/feasibility/feasibility.component';
import { OperatorPopupComponent } from './components/taskcost/operator-popup/operator-popup.component';
import { VoyageCreditPurchaseComponent } from './components/taskcost/voyage-credit-purchase/voyage-credit-purchase.component';
import { VesselFinderCreditPurchaseComponent } from './components/taskcost/vesselfinder-credit-purchase/vesselfinder-credit-purchase.component';
import { CloudCoverComponent } from './components/cloud-cover/cloud-cover.component';
import { CatalogsPopupComponent } from './components/my-task/catalogs-popup/catalogs-popup.component';
import { ReturnRefundComponent } from './components/collections/return-refund/return-refund.component';
import { FundAllocationComponent } from './components/fund-allocation/fund-allocation.component';
import { PaymentNotificationComponent } from './components/payment/payment-notification/payment-notification.component';
import { AllocationNotificationComponent } from './components/fund-allocation/allocation-notification/allocation-notification.component';

import { StarRatingComponent } from './components/my-task/star-rating/star-rating.component';
import { FilterPopupComponent } from './components/collections/filter-popup/filter-popup.component';
import { BudgetsComponent } from './components/budgets/budgets.component';
import { BudgetpopupComponent } from './components/newtask/budgetpopup/budgetpopup.component';
import { WarningPopupComponent } from './components/collections/warning-popup/warning-popup.component';
import { OpportunityComponent } from './components/my-task/opportunity/opportunity.component';
import { RetaskOptionsDialogComponent } from './components/my-task/retask-options-dialog/retask-options-dialog.component';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { CreateTaskConfirmDialog } from './components/collections/confirm-dialog/confirmdialog'
import { QuotationPopupComponent } from './components/userregister/quotation-popup/quotation-popup.component';
import { QuotesComponent } from './components/quotes/quotes.component';
import { SupportTicketCreateComponent } from './components/support-tickets/support-ticket-create.component';
import { SupportTicketDetailComponent } from './components/support-tickets/support-ticket-detail.component';
import { SupportTicketListComponent } from './components/support-tickets/support-ticket-list.component';
import { DecimalPipe } from '@angular/common';
import { CustomTooltipDirective } from './components/my-task/custom-tooltip/custom-tooltip.directive';
// import { MatTooltipModule } from '@angular/material/tooltip';
import { LeafletFeasibilityPreviewComponent } from './components/my-task/feasibility/leaflet-feasibility-preview/leaflet-feasibility-preview.component';
import { LeafletTaskComponent } from './components/leaflet-task/leaflet-task.component';
import { FeedGeojsonUploadDialogComponent } from './components/leaflet-task/feed-geojson-upload-dialog/feed-geojson-upload-dialog.component';
import { FeedSentinelAgreementDialogComponent } from './components/leaflet-task/feed-sentinel-agreement-dialog/feed-sentinel-agreement-dialog.component';
import { TaskCloudCalendarHeaderComponent } from './components/leaflet-task/task-cloud-calendar-header.component';
import { LeafletTaskIntentPanelComponent } from './components/leaflet-task/intent-panel/leaflet-task-intent-panel.component';
import { LeafletTaskValidityIndicatorComponent } from './components/leaflet-task/intent-panel/leaflet-task-validity-indicator.component';
// The AIS map, one module per vendor (D16). Each ships its own components,
// its control descriptors and its bar composition; adding a sensor means
// adding a module here and editing nothing else in this file.
import { AisSharedModule } from './components/leaflet-newcollections/ais/shared/ais-shared.module';
import { VoyageRadarModule } from './components/leaflet-newcollections/ais/voyage-radar/voyage-radar.module';
import { VesselFinderModule } from './components/leaflet-newcollections/ais/vesselfinder/vesselfinder.module';
import { AisstreamModule } from './components/leaflet-newcollections/ais/aisstream/aisstream.module';
import { LeafletNewcollectionsComponent } from './components/leaflet-newcollections/leaflet-newcollections.component';
import { WeatherexForecastTimelineComponent } from './components/leaflet-newcollections/weatherex-forecast-timeline/weatherex-forecast-timeline.component';
import { WeatherexPointDrawerComponent } from './components/leaflet-newcollections/weatherex-point-drawer/weatherex-point-drawer.component';
import { WeatherexPointTooltipComponent } from './components/leaflet-newcollections/weatherex-point-tooltip/weatherex-point-tooltip.component';
import { CollectionReportDialogComponent } from './components/leaflet-newcollections/collection-report-dialog/collection-report-dialog.component';
import { LeafletNewpreviewComponent } from './components/leaflet-newpreview/leaflet-newpreview.component';
// import { WhatsNewComponent } from './components/shared/footer/whats-new/whats-new.component';
// import { RequiredPopupComponent } from './components/taskcost/required-popup/required-popup.component';
// import { UserManagementComponent } from './components/user-management/user-management.component';
// import { TaskcostSensorPreviewComponent } from './components/newtask/taskcost-sensor-preview/taskcost-sensor-preview.component';
// import { HistoryActionsComponent } from './components/history-actions/history-actions.component';
// import { EulaIntroductionComponent } from './components/payment/eula-introduction/eula-introduction.component';

import { RequiredPopupComponent } from './components/taskcost/required-popup/required-popup.component';

import { TaskAgreementDialogComponent } from './components/collections/task-agreement-dialog/task-agreement-dialog.component';
import { PreviewGeojsonLeafletMapComponent } from './components/taskcost/preview-geojson-leaflet-map/preview-geojson-leaflet-map';
import { PreviewGeojsonComponent } from './components/taskcost/previewgeojson/previewgeojson.component';
import { AnnouncementBannerComponent } from './components/my-task/announcement-banner/announcement-banner.component';
import { WildcardRedirectComponent } from './components/shared/utils/wildcard-redirect-componenet';
import { LeafletUserPreviescreenComponent } from './components/leaflet-user-previescreen/leaflet-user-previescreen.component';
import { ChatBotComponent } from './components/chat-bot/chat-bot.component';
// import { DragDropModule } from '@angular/cdk/drag-drop';
// import { MatBadgeModule } from '@angular/material/badge';
import { APP_DATE_FORMATS, CustomDateAdapter } from './components/shared';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule} from '@angular/cdk/clipboard';
import { BandSelectorComponent } from './components/shared/band-selector/band-selector.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatChipsModule } from '@angular/material/chips';
import { CapellaFilterComponent } from './components/popups/capella-filter/capella-filter.component';
import { TaskTypeModalComponent } from './components/my-task/task-type/task-type.component';

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    AppLayoutComponent,
    UserloginComponent,
    UserregisterComponent,
    MyTaskComponent,
    ProfileComponent,
    OrdersComponent,
    // FooterComponent,
    // BgSliderComponent,
    ForgotComponent,
    SidebarComponent,
    SignupComponent,
    OtpComponent,
    NewpassComponent,
    SliderComponent,
    TopbarComponent,
    PreviewGeojsonComponent,
    ActionComponent,
    TaskcostComponent,
    PaymentComponent,
    CartComponent,
    NotificationComponent,
    AddbalanceComponent,
    DebitsuccessComponent,
    UploadphotoComponent,
    CancelsensorComponent,
    InnerTaskComponent,
    ResetpasswordComponent,
    DeleteComponent,
    GlobeComponent,
    SuccessComponent,
    ConfirmDialog,
    SafePipe,
    PaypalsuccessComponent,
    ErrorComponent,
    PaymentsuccessComponent,
    NoCartComponent,
    RequestDemoComponent,
    OpenconfirmwarningComponent,
    RegistersuccessComponent,
    CountrycheckComponent,
    CancelinvoiceComponent,
    CancelpaylaterComponent,
    SatellogicWarningComponent,
    DesktopVersionComponent,
    DepositsComponent,
    ToiWarningPopupComponent,
    NotFoundComponent,
    FeasibilityComponent,
    OperatorPopupComponent,
    VoyageCreditPurchaseComponent,
    VesselFinderCreditPurchaseComponent,
    CloudCoverComponent,
    CatalogsPopupComponent,
    SubscriptionComponent,
    ReturnRefundComponent,
    FundAllocationComponent,
    PaymentNotificationComponent,
    AllocationNotificationComponent,
    StarRatingComponent,
    FilterPopupComponent,
    WarningPopupComponent,
    OpportunityComponent,
    RetaskOptionsDialogComponent,
    BudgetsComponent,
    BudgetpopupComponent,
    CreateTaskConfirmDialog,
    QuotationPopupComponent,
    QuotesComponent,
    SupportTicketListComponent,
    SupportTicketCreateComponent,
    SupportTicketDetailComponent,
    CustomTooltipDirective,
    LeafletTaskComponent,
    FeedGeojsonUploadDialogComponent,
    FeedSentinelAgreementDialogComponent,
    TaskCloudCalendarHeaderComponent,
    LeafletTaskIntentPanelComponent,
    LeafletTaskValidityIndicatorComponent,
    LeafletNewcollectionsComponent,
    WeatherexForecastTimelineComponent,
    WeatherexPointDrawerComponent,
    WeatherexPointTooltipComponent,
    CollectionReportDialogComponent,
    LeafletNewpreviewComponent,
    LeafletFeasibilityPreviewComponent,
    // WhatsNewComponent,
    RequiredPopupComponent,
    // UserManagementComponent,
    // TaskcostSensorPreviewComponent,
    // HistoryActionsComponent,
    // EulaIntroductionComponent,
    // RequiredPopupComponent,
    TaskAgreementDialogComponent,
    AnnouncementBannerComponent,
    WildcardRedirectComponent,
    PreviewGeojsonLeafletMapComponent,
    LeafletUserPreviescreenComponent,
    ChatBotComponent,
    BandSelectorComponent,
    CapellaFilterComponent,
    TaskTypeModalComponent
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    AisSharedModule,
    VoyageRadarModule,
    VesselFinderModule,
    AisstreamModule,
      BrowserModule,
      SharedModule,
      HttpClientModule,
      FormsModule,
      ReactiveFormsModule,
      BrowserAnimationsModule,
      AppRoutingModule,
      NgxDropzoneModule,
      NgxIntlTelInputModule,
      NgImageSliderModule,
      CarouselModule,
      ImageCropperModule,
      ObserversModule,
      RecaptchaV3Module,
      NgxOtpInputModule,
      DragDropModule,
      ClipboardModule,
      ScrollingModule,
      MatChipsModule,
    ],

  providers: [
    { provide: AuthService,},
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    ValidationService, DatePipe, DecimalPipe,
    // Voyage Radar contributes its own controls into the same multi-token, so
    // `ais/shared/` no longer imports a single provider component (D7
    // amendment). A new provider adds one file here and edits nothing shared.
    // Two lines per provider: its controls, then its bars. Both feed `multi`
    // tokens, so a new sensor adds its own pair and edits nothing shared (D13).
  ],
  bootstrap: [AppComponent],
})
export class AppModule {

}
